// eslint-disable-next-line import/no-unresolved
const registerCSSInterfaceWithDefaultTheme = require('./lib/utils/registerCSSInterfaceWithDefaultTheme.js').default;

registerCSSInterfaceWithDefaultTheme();
